export enum BetType {
	THLBHi,
	THLBLo,
	THLBElevenHiLo,
	THLBSpecificNumberOne,
	THLBSpecificNumberTwo,
	THLBSpecificNumberThree,
	THLBSpecificNumberFour,
	THLBSpecificNumberFive,
	THLBSpecificNumberSix,
	THLBSpecificDoubleOneTwo,
	THLBSpecificDoubleOneThree,
	THLBSpecificDoubleTwoThree,
	THLBSpecificDoubleThreeFour,
	THLBSpecificDoubleFourOne,
	THLBSpecificDoubleFourTwo,
	THLBSpecificDoubleFourFive,
	THLBSpecificDoubleFourSix,
	THLBSpecificDoubleFiveOne,
	THLBSpecificDoubleFiveTwo,
	THLBSpecificDoubleFiveThree,
	THLBSpecificDoubleFiveSix,
	THLBSpecificDoubleSixOne,
	THLBSpecificDoubleSixTwo,
	THLBSpecificDoubleSixThree,
	THLBOneTwoThree,
	THLBFourFiveSix,
	THLBOneLo,
	THLBTwoLo,
	THLBThreeLo,
	THLBFourLo,
	THLBFiveLo,
	THLBSixLo,
	THLBThreeHi,
	THLBFourHi,
	THLBFiveHi,
	THLBSixHi,

	THLBMaxBet,
}